import { Flex, FlexProps, Text } from "@chakra-ui/react";
import { getComponentStyle } from "components/containers/InspectionFormat/Content/SettingFontSize/utils/style";
import { BlackboardPosition } from "interfaces/models/blackboard";
import { PinComponentStyle } from "interfaces/models/pinComponent";

const DEFAULT_BLACKBOARD_SCALE = 1 / 5;

export const getBlackboardContentText = (params: {
  value: any;
  style: PinComponentStyle | undefined;
  zoomRatio: number;
  boxProps?: FlexProps;
}) => {
  const { value, style, zoomRatio, boxProps } = params;
  const newStyle = getComponentStyle(style);

  return (
    <Flex
      {...newStyle}
      fontSize={`${newStyle.fontSize * zoomRatio}px`}
      height="100%"
      width="100%"
      {...boxProps}
    >
      <Text width="100%">{value}</Text>
    </Flex>
  );
};

export const checkIsInitDefaultBlackboardPosition = (args: {
  blackboardFormatWidth: number | undefined;
  blackboardFormatHeight: number | undefined;
  blackboardPosition: BlackboardPosition | undefined;
}) => {
  const { blackboardFormatHeight, blackboardFormatWidth, blackboardPosition } =
    args;

  if (
    !blackboardPosition ||
    !blackboardFormatWidth ||
    !blackboardFormatHeight
  ) {
    return true;
  }

  const blackboardAspectRatio = blackboardFormatWidth / blackboardFormatHeight;
  const isDiffRatio =
    Number(
      (
        blackboardPosition.blackboardWidth / blackboardPosition.blackboardHeight
      ).toFixed(2)
    ) !== Number(blackboardAspectRatio.toFixed(2));

  return isDiffRatio;
};

export const handleInitDefaultBlackboardPosition = (args: {
  boundWidth: number;
  boundHeight: number;
  blackboardFormatWidth: number | undefined;
  blackboardFormatHeight: number | undefined;
}) => {
  const {
    boundWidth,
    boundHeight,
    blackboardFormatWidth,
    blackboardFormatHeight,
  } = args;
  if (
    !boundWidth ||
    !boundHeight ||
    !blackboardFormatWidth ||
    !blackboardFormatHeight
  ) {
    return;
  }

  const ratio = blackboardFormatWidth / blackboardFormatHeight;
  const blackboardWidth = boundWidth * DEFAULT_BLACKBOARD_SCALE;
  const blackboardHeight = blackboardWidth / ratio;
  const positionY = boundHeight - blackboardHeight;

  return {
    position: { x: 0, y: positionY },
    size: {
      width: blackboardWidth,
      height: blackboardHeight,
    },
  };
};

export const handleScaleBlackboardPosition = (args: {
  boundWidth: number;
  boundHeight: number;
  blackboardPosition: BlackboardPosition;
}) => {
  const { boundWidth, boundHeight, blackboardPosition } = args;
  const { blackboardWidth, blackboardHeight, imageWidth, imageHeight, x, y } =
    blackboardPosition;

  const ratioImageWidth = boundWidth / imageWidth;
  const ratioImageHeight = boundHeight / imageHeight;

  const width = blackboardWidth * ratioImageWidth;
  const height = blackboardHeight * ratioImageHeight;
  const positionX = x * ratioImageWidth;
  const positionY = y * ratioImageHeight;

  return { position: { x: positionX, y: positionY }, size: { width, height } };
};
